// extracted by mini-css-extract-plugin
export default {"spotifyIcon":"login-button_spotifyIcon__xPozt","spotifyLoginButton":"login-button_spotifyLoginButton__4DBzs","small":"login-button_small__V5uh4"};